export default __webpack_public_path__ + "static/media/AvatarKids-06.eb6246c4.png";